// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import SensorApi from "../../Apis/SensorApi";

const SensorsStockPage = ({ SensprValid, onStorageResponse }) => {

    const [Allergens, setAllergens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);


    const fetchAllergens = async () => {
        try {
            setLoading(true);
            SensorApi.ListSensors(page, 10)
                .then((response) => {
                    setTotalPageNew(response.totalPages);
                    setAllergens(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

                    setPage(prevPage => prevPage + 1);
                    setLoading(false);

                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
        if (bottom || nearBottom) {
            if (TotalPageNew > page) {
                fetchAllergens();
            }
        }
    };
    useEffect(() => {

        fetchAllergens();
    }, []);
    const handleChangeProduct = (value) => {

        SensorApi.SingleSensors(value).then((response) => {
            onStorageResponse(response.payload);

        })
            .catch((err) => {
                console.log(err);
            });
    };
    return (
        <>
            <Form.Item
                name="SensorID"
                label="Sensor :"
                className="text-lable  "
                rules={SensprValid ? [
                    {
                        required: true,
                        message: "Please Select Sensor",
                    },
                ] : []}
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Sensor"
                    onPopupScroll={handleScroll}
                    onChange={(value) => handleChangeProduct(value)}
                >
                    {Allergens.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.name}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item >

        </>

    );
};

export default SensorsStockPage;
